import type { ReactElement } from "react";
import styles from "./ProgressRow.module.css";

export interface ProgressRowProps {
  label: string;
  /** Progress fill width for the track, 0–100. */
  fillPercent: number;
  sideText: string;
  title?: string;
  /** Handset drawer sizing — matches drawer checkbox rows. */
  drawerRail?: boolean;
}

/** Label + slider-style progress track + muted side text (Property Report stats). */
export function ProgressRow({
  label,
  fillPercent,
  sideText,
  title,
  drawerRail = false
}: ProgressRowProps): ReactElement {
  const clampedFill = Math.min(100, Math.max(0, fillPercent));
  const rowClass = [styles.row, drawerRail ? styles.rowDrawerRail : null]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rowClass} title={title}>
      <span className={styles.label}>{label}</span>
      <div className={styles.trackWrap} aria-hidden>
        <div className={styles.track}>
          <div
            className={styles.trackFill}
            style={{ width: `${clampedFill.toFixed(1)}%` }}
          />
        </div>
      </div>
      <span className={styles.sideText}>{sideText}</span>
    </div>
  );
}
